/// <reference path="../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../../node_modules/@types/jquery.validation/index.d.ts" />
/// <reference path="../../node_modules/@types/jquery-validation-unobtrusive/index.d.ts" />

export class EligibilityValidateAlt {

    public static Init() {

        (<any>$("#EligibilityInfo_CustomerPhoneNumber")).mask("(000) 000-0000", { clearIfNotMatch: false });
        (<any>$("#EligibilityInfo_ZipCode")).mask("00000", { clearIfNotMatch: false });
        var accountNumberMask = $('#AccountNumberMask').val() as string;
        if (accountNumberMask != null && accountNumberMask.length) {
            var accountPlaceholder = "_".repeat(accountNumberMask.length);
            (<any>$("#EligibilityInfo_BillingNumber")).mask(accountNumberMask, { clearIfNotMatch: false, placeholder: accountPlaceholder });
        }
        
        this.BindSubmitButtonHandler();

    }

    ///Continue button handles the "submit" on the page
    ///Make sure only one "click" event is processed.
    ///Note: one() will remove the click handler, so if validation fails, it needs to be reattached.
    public static BindSubmitButtonHandler() {
        $("#submitButton").one('click', (evt) => {
            if ($("#validate-form").valid()) {
                $(evt.target).slideUp();
                $("#validate-form").trigger("submit");
            } else {
                EligibilityValidateAlt.BindSubmitButtonHandler();
            }
        });
    }
    

}

((window: any, document: any) => {
    $(() => {
        EligibilityValidateAlt.Init();
    });
})(window, document);